module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-base-14.84094a4d.png";